module.exports = __webpack_public_path__ + "img/arrow.2ccd72f0.png";